const { scriptTag, load, unload } = useScriptTag(
  '/js/telegram-web-app.js',
  () => {
    // do something
  },
  { manual: true }
)

// Флаг для предотвращения повторной регистрации
let isInitialized = false
let backButtonHandler = null

export default defineNuxtPlugin(async ({ vueApp }) => {
  // Плагины могут вызываться несколько раз, защищаемся от повторной инициализации
  if (isInitialized || !process.client) {
    return
  }

  // На /live обёртка Telegram не нужна: страница полностью автономна, а
  // requestFullscreen/lockOrientation отсюда конфликтуют с фулскрином и
  // поворотом экрана, которыми управляет сам плеер стрима
  if (window.location.pathname.startsWith('/live')) {
    return
  }

  await load()
  const TGApp = window.Telegram.WebApp

  if (!TGApp) {
    return
  }

  isInitialized = true

  TGApp.ready()
  TGApp.expand()
  TGApp.BackButton.show()

  TGApp.setHeaderColor('#122238')
  TGApp.setBackgroundColor('#122238')

  if (window.Telegram.WebView.initParams.tgWebAppPlatform == 'tdesktop' || window.Telegram.WebView.initParams.tgWebAppPlatform == 'macos') {
    try {
      TGApp.exitFullscreen()
    } catch (er) {
      console.log(er)
    }
  } else {
    try {
      TGApp.requestFullscreen()
      TGApp.lockOrientation()
    } catch (er) {
      console.log(er)
    }
  }

  // Создаем handler один раз и сохраняем ссылку
  backButtonHandler = () => {
    window.history.go(-1)
  }

  TGApp.onEvent('backButtonClicked', backButtonHandler)
  TGApp.enableClosingConfirmation()
  // TGApp.SettingsButton.show()
})
